import { inputs } from '@ecosystem/newron-design-system';
import React, { useCallback, useState } from 'react';

const { TextInput } = inputs;
interface SearchAreaProps {
  placeholder: string;
  onSearch: (searchTerm: string) => void;
}
export const NO_SEARCH_RESULTS_MESSAGE = 'No results can be found';

export const SearchArea: React.FC<SearchAreaProps> = ({ placeholder, onSearch }) => {
  const [searchTerm, setSearchTerm] = useState<string>('');

  // Call onSearch on every input change
  const handleChange = useCallback(
    (value: string) => {
      setSearchTerm(value);
      onSearch(value);
    },
    [onSearch]
  );

  return (
    <div className="flex flex-column gap-3">
      <TextInput placeholder={placeholder} value={searchTerm} onChange={handleChange} testId="search-input"></TextInput>
    </div>
  );
};
